import cookies from './util.cookies'
import db from './util.db'
import log from './util.log'

const util = {
  cookies,
  db,
  log
}

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function (titleText) {
  const processTitle = process.env.VUE_APP_TITLE || 'D2Admin'
  window.document.title = `${processTitle}${titleText ? ` | ${titleText}` : ''}`
}

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = function (url) {
  var a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_blank')
  a.setAttribute('id', 'd2admin-link-temp')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(document.getElementById('d2admin-link-temp'))
}

/**
 * @description 字符串长度（英文占1个字符，中文汉字占2个字符）
 * @param {String} str 字符串
 * @return {Number} 长度
 */
const getBLen = function (str) {
  if (str == null) return 0
  if (typeof str !== 'string') {
    str += ''
  }
  // eslint-disable-next-line no-control-regex
  return str.replace(/[^\x00-\xff]/g, '01').length
}
util.getBLen = getBLen

/**
 * @description 字符长度是否在规定长度范围内
 * @param {String} str 字符串
 * @param {Number} min 最小长度
 * @param {Number} max 最大长度
 * @param {Boolean} isCn2 汉字是否代表两个字节
 * @return {Boolean} 1 、0
 */
const isStrInRange = function (str, min, max, isCn2 = true) {
  const le = (isCn2 ? getBLen(str) : str.length) || 0
  return le >= min && le <= max
}
util.isStrInRange = isStrInRange

export default util
